const Countries = [
    {
        label: 'UNITED STATES',
        value: 'US'
    },
    {
        label: 'UNITED KINGDOM',
        value: 'GB'
    },
    {
        label: 'JAPAN',
        value: 'JP'
    },
    {
        label: 'KOREA, REPUBLIC OF',
        value: 'KR'
    },
    {
        label: 'CHINA',
        value: 'CN'
    },
    {
        label: 'AFGHANISTAN',
        value: 'AF'
    },
    {
        label: 'ÅLAND ISLANDS',
        value: 'AX'
    },
    {
        label: 'ALBANIA',
        value: 'AL'
    },
    {
        label: 'ALGERIA',
        value: 'DZ'
    },
    {
        label: 'AMERICAN SAMOA',
        value: 'AS'
    },
    {
        label: 'ANDORRA',
        value: 'AD'
    },
    {
        label: 'ANGOLA',
        value: 'AO'
    },
    {
        label: 'ANGUILLA',
        value: 'AI'
    },
    {
        label: 'ANTARCTICA',
        value: 'AQ'
    },
    {
        label: 'ANTIGUA AND BARBUDA',
        value: 'AG'
    },
    {
        label: 'ARGENTINA',
        value: 'AR'
    },
    {
        label: 'ARMENIA',
        value: 'AM'
    },
    {
        label: 'ARUBA',
        value: 'AW'
    },
    {
        label: 'AUSTRALIA',
        value: 'AU'
    },
    {
        label: 'AUSTRIA',
        value: 'AT'
    },
    {
        label: 'AZERBAIJAN',
        value: 'AZ'
    },
    {
        label: 'BAHAMAS',
        value: 'BS'
    },
    {
        label: 'BAHRAIN',
        value: 'BH'
    },
    {
        label: 'BANGLADESH',
        value: 'BD'
    },
    {
        label: 'BARBADOS',
        value: 'BB'
    },
    {
        label: 'BELARUS',
        value: 'BY'
    },
    {
        label: 'BELGIUM',
        value: 'BE'
    },
    {
        label: 'BELIZE',
        value: 'BZ'
    },
    {
        label: 'BENIN',
        value: 'BJ'
    },
    {
        label: 'BERMUDA',
        value: 'BM'
    },
    {
        label: 'BHUTAN',
        value: 'BT'
    },
    {
        label: 'BOLIVIA',
        value: 'BO'
    },
    {
        label: 'BOSNIA AND HERZEGOVINA',
        value: 'BA'
    },
    {
        label: 'BOTSWANA',
        value: 'BW'
    },
    {
        label: 'BOUVET ISLAND',
        value: 'BV'
    },
    {
        label: 'BRAZIL',
        value: 'BR'
    },
    {
        label: 'BRITISH INDIAN OCEAN TERRITORY',
        value: 'IO'
    },
    {
        label: 'BRUNEI DARUSSALAM',
        value: 'BN'
    },
    {
        label: 'BULGARIA',
        value: 'BG'
    },
    {
        label: 'BURKINA FASO',
        value: 'BF'
    },
    {
        label: 'BURUNDI',
        value: 'BI'
    },
    {
        label: 'CAMBODIA',
        value: 'KH'
    },
    {
        label: 'CAMEROON',
        value: 'CM'
    },
    {
        label: 'CANADA',
        value: 'CA'
    },
    {
        label: 'CAPE VERDE',
        value: 'CV'
    },
    {
        label: 'CAYMAN ISLANDS',
        value: 'KY'
    },
    {
        label: 'CENTRAL AFRICAN REPUBLIC',
        value: 'CF'
    },
    {
        label: 'CHAD',
        value: 'TD'
    },
    {
        label: 'CHILE',
        value: 'CL'
    },
    {
        label: 'CHRISTMAS ISLAND',
        value: 'CX'
    },
    {
        label: 'COCOS (KEELING) ISLANDS',
        value: 'CC'
    },
    {
        label: 'COLOMBIA',
        value: 'CO'
    },
    {
        label: 'COMOROS',
        value: 'KM'
    },
    {
        label: 'CONGO',
        value: 'CG'
    },
    {
        label: 'CONGO, DEMOCRATIC REPUBLIC OF THE',
        value: 'CD'
    },
    {
        label: 'COOK ISLANDS',
        value: 'CK'
    },
    {
        label: 'COSTA RICA',
        value: 'CR'
    },
    {
        label: "COTE D'IVOIRE",
        value: 'CI'
    },
    {
        label: 'CROATIA',
        value: 'HR'
    },
    {
        label: 'CYPRUS',
        value: 'CY'
    },
    {
        label: 'CZECH REPUBLIC',
        value: 'CZ'
    },
    {
        label: 'DENMARK',
        value: 'DK'
    },
    {
        label: 'DJIBOUTI',
        value: 'DJ'
    },
    {
        label: 'DOMINICA',
        value: 'DM'
    },
    {
        label: 'DOMINICAN REPUBLIC',
        value: 'DO'
    },
    {
        label: 'ECUADOR',
        value: 'EC'
    },
    {
        label: 'EGYPT',
        value: 'EG'
    },
    {
        label: 'EL SALVADOR',
        value: 'SV'
    },
    {
        label: 'EQUATORIAL GUINEA',
        value: 'GQ'
    },
    {
        label: 'ERITREA',
        value: 'ER'
    },
    {
        label: 'ESTONIA',
        value: 'EE'
    },
    {
        label: 'ETHIOPIA',
        value: 'ET'
    },
    {
        label: 'FALKLAND ISLANDS (MALVINAS)',
        value: 'FK'
    },
    {
        label: 'FAROE ISLANDS',
        value: 'FO'
    },
    {
        label: 'FIJI',
        value: 'FJ'
    },
    {
        label: 'FINLAND',
        value: 'FI'
    },
    {
        label: 'FRANCE',
        value: 'FR'
    },
    {
        label: 'FRENCH GUIANA',
        value: 'GF'
    },
    {
        label: 'FRENCH POLYNESIA',
        value: 'PF'
    },
    {
        label: 'FRENCH SOUTHERN TERRITORIES',
        value: 'TF'
    },
    {
        label: 'GABON',
        value: 'GA'
    },
    {
        label: 'GAMBIA',
        value: 'GM'
    },
    {
        label: 'GEORGIA',
        value: 'GE'
    },
    {
        label: 'GERMANY',
        value: 'DE'
    },
    {
        label: 'GHANA',
        value: 'GH'
    },
    {
        label: 'GIBRALTAR',
        value: 'GI'
    },
    {
        label: 'GREECE',
        value: 'GR'
    },
    {
        label: 'GREENLAND',
        value: 'GL'
    },
    {
        label: 'GRENADA',
        value: 'GD'
    },
    {
        label: 'GUADELOUPE',
        value: 'GP'
    },
    {
        label: 'GUAM',
        value: 'GU'
    },
    {
        label: 'GUATEMALA',
        value: 'GT'
    },
    {
        label: 'GUERNSEY',
        value: 'GG'
    },
    {
        label: 'GUINEA-BISSAU',
        value: 'GW'
    },
    {
        label: 'GUINEA',
        value: 'GN'
    },
    {
        label: 'GUYANA',
        value: 'GY'
    },
    {
        label: 'HAITI',
        value: 'HT'
    },
    {
        label: 'HEARD ISLAND AND MCDONALD ISLANDS',
        value: 'HM'
    },
    {
        label: 'HOLY SEE (VATICAN CITY STATE)',
        value: 'VA'
    },
    {
        label: 'HONDURAS',
        value: 'HN'
    },
    {
        label: 'HONG KONG',
        value: 'HK'
    },
    {
        label: 'HUNGARY',
        value: 'HU'
    },
    {
        label: 'ICELAND',
        value: 'IS'
    },
    {
        label: 'INDIA',
        value: 'IN'
    },
    {
        label: 'INDONESIA',
        value: 'ID'
    },
    {
        label: 'IRAQ',
        value: 'IQ'
    },
    {
        label: 'IRELAND',
        value: 'IE'
    },
    {
        label: 'ISLE OF MAN',
        value: 'IM'
    },
    {
        label: 'ISRAEL',
        value: 'IL'
    },
    {
        label: 'ITALY',
        value: 'IT'
    },
    {
        label: 'JAMAICA',
        value: 'JM'
    },
    {
        label: 'JERSEY',
        value: 'JE'
    },
    {
        label: 'JORDAN',
        value: 'JO'
    },
    {
        label: 'KAZAKHSTAN',
        value: 'KZ'
    },
    {
        label: 'KENYA',
        value: 'KE'
    },
    {
        label: 'KIRIBATI',
        value: 'KI'
    },
    {
        label: 'KUWAIT',
        value: 'KW'
    },
    {
        label: 'KYRGYZSTAN',
        value: 'KG'
    },
    {
        label: 'KOSOVO',
        value: 'XK'
    },
    {
        label: "LAO PEOPLE'S DEMOCRATIC REPUBLIC",
        value: 'LA'
    },
    {
        label: 'LATVIA',
        value: 'LV'
    },
    {
        label: 'LEBANON',
        value: 'LB'
    },
    {
        label: 'LESOTHO',
        value: 'LS'
    },
    {
        label: 'LIBYA',
        value: 'LY'
    },
    {
        label: 'LIECHTENSTEIN',
        value: 'LI'
    },
    {
        label: 'LITHUANIA',
        value: 'LT'
    },
    {
        label: 'LUXEMBOURG',
        value: 'LU'
    },
    {
        label: 'MACAO',
        value: 'MO'
    },
    {
        label: 'MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF',
        value: 'MK'
    },
    {
        label: 'MADAGASCAR',
        value: 'MG'
    },
    {
        label: 'MALAWI',
        value: 'MW'
    },
    {
        label: 'MALAYSIA',
        value: 'MY'
    },
    {
        label: 'MALDIVES',
        value: 'MV'
    },
    {
        label: 'MALI',
        value: 'ML'
    },
    {
        label: 'MALTA',
        value: 'MT'
    },
    {
        label: 'MARSHALL ISLANDS',
        value: 'MH'
    },
    {
        label: 'MARTINIQUE',
        value: 'MQ'
    },
    {
        label: 'MAURITANIA',
        value: 'MR'
    },
    {
        label: 'MAURITIUS',
        value: 'MU'
    },
    {
        label: 'MAYOTTE',
        value: 'YT'
    },
    {
        label: 'MEXICO',
        value: 'MX'
    },
    {
        label: 'MICRONESIA, FEDERATED STATES OF',
        value: 'FM'
    },
    {
        label: 'MOLDOVA, REPUBLIC OF',
        value: 'MD'
    },
    {
        label: 'MONACO',
        value: 'MC'
    },
    {
        label: 'MONGOLIA',
        value: 'MN'
    },
    {
        label: 'MONTENEGRO',
        value: 'ME'
    },
    {
        label: 'MONTSERRAT',
        value: 'MS'
    },
    {
        label: 'MOROCCO',
        value: 'MA'
    },
    {
        label: 'MOZAMBIQUE',
        value: 'MZ'
    },
    {
        label: 'MYANMAR',
        value: 'MM'
    },
    {
        label: 'NAMIBIA',
        value: 'NA'
    },
    {
        label: 'NAURU',
        value: 'NR'
    },
    {
        label: 'NEPAL',
        value: 'NP'
    },
    {
        label: 'NETHERLANDS ANTILLES',
        value: 'AN'
    },
    {
        label: 'NETHERLANDS',
        value: 'NL'
    },
    {
        label: 'NEW CALEDONIA',
        value: 'NC'
    },
    {
        label: 'NEW ZEALAND',
        value: 'NZ'
    },
    {
        label: 'NICARAGUA',
        value: 'NI'
    },
    {
        label: 'NIGER',
        value: 'NE'
    },
    {
        label: 'NIGERIA',
        value: 'NG'
    },
    {
        label: 'NIUE',
        value: 'NU'
    },
    {
        label: 'NORFOLK ISLAND',
        value: 'NF'
    },
    {
        label: 'NORTHERN MARIANA ISLANDS',
        value: 'MP'
    },
    {
        label: 'NORWAY',
        value: 'NO'
    },
    {
        label: 'OMAN',
        value: 'OM'
    },
    {
        label: 'PAKISTAN',
        value: 'PK'
    },
    {
        label: 'PALAU',
        value: 'PW'
    },
    {
        label: 'PALESTINIAN TERRITORY, OCCUPIED',
        value: 'PS'
    },
    {
        label: 'PANAMA',
        value: 'PA'
    },
    {
        label: 'PAPUA NEW GUINEA',
        value: 'PG'
    },
    {
        label: 'PARAGUAY',
        value: 'PY'
    },
    {
        label: 'PERU',
        value: 'PE'
    },
    {
        label: 'PHILIPPINES',
        value: 'PH'
    },
    {
        label: 'PITCAIRN',
        value: 'PN'
    },
    {
        label: 'POLAND',
        value: 'PL'
    },
    {
        label: 'PORTUGAL',
        value: 'PT'
    },
    {
        label: 'PUERTO RICO',
        value: 'PR'
    },
    {
        label: 'QATAR',
        value: 'QA'
    },
    {
        label: 'REUNION',
        value: 'RE'
    },
    {
        label: 'ROMANIA',
        value: 'RO'
    },
    {
        label: 'RUSSIAN FEDERATION',
        value: 'RU'
    },
    {
        label: 'RWANDA',
        value: 'RW'
    },
    {
        label: 'SAINT HELENA',
        value: 'SH'
    },
    {
        label: 'SAINT KITTS AND NEVIS',
        value: 'KN'
    },
    {
        label: 'SAINT LUCIA',
        value: 'LC'
    },
    {
        label: 'SAINT PIERRE AND MIQUELON',
        value: 'PM'
    },
    {
        label: 'SAINT VINCENT AND THE GRENADINES',
        value: 'VC'
    },
    {
        label: 'SAMOA',
        value: 'WS'
    },
    {
        label: 'SAN MARINO',
        value: 'SM'
    },
    {
        label: 'SAO TOME AND PRINCIPE',
        value: 'ST'
    },
    {
        label: 'SAUDI ARABIA',
        value: 'SA'
    },
    {
        label: 'SENEGAL',
        value: 'SN'
    },
    {
        label: 'SEYCHELLES',
        value: 'SC'
    },
    {
        label: 'SERBIA',
        value: 'RS'
    },
    {
        label: 'SIERRA LEONE',
        value: 'SL'
    },
    {
        label: 'SINGAPORE',
        value: 'SG'
    },
    {
        label: 'SLOVAKIA',
        value: 'SK'
    },
    {
        label: 'SLOVENIA',
        value: 'SI'
    },
    {
        label: 'SOLOMON ISLANDS',
        value: 'SB'
    },
    {
        label: 'SOMALIA',
        value: 'SO'
    },
    {
        label: 'SOUTH AFRICA',
        value: 'ZA'
    },
    {
        label: 'SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS',
        value: 'GS'
    },
    {
        label: 'SPAIN',
        value: 'ES'
    },
    {
        label: 'SRI LANKA',
        value: 'LK'
    },
    {
        label: 'SURINAME',
        value: 'SR'
    },
    {
        label: 'SVALBARD AND JAN MAYEN',
        value: 'SJ'
    },
    {
        label: 'SWAZILAND',
        value: 'SZ'
    },
    {
        label: 'SWEDEN',
        value: 'SE'
    },
    {
        label: 'SWITZERLAND',
        value: 'CH'
    },
    {
        label: 'TAIWAN',
        value: 'TW'
    },
    {
        label: 'TAJIKISTAN',
        value: 'TJ'
    },
    {
        label: 'TANZANIA, UNITED REPUBLIC OF',
        value: 'TZ'
    },
    {
        label: 'THAILAND',
        value: 'TH'
    },
    {
        label: 'TIMOR-LESTE',
        value: 'TL'
    },
    {
        label: 'TOGO',
        value: 'TG'
    },
    {
        label: 'TOKELAU',
        value: 'TK'
    },
    {
        label: 'TONGA',
        value: 'TO'
    },
    {
        label: 'TRINIDAD AND TOBAGO',
        value: 'TT'
    },
    {
        label: 'TUNISIA',
        value: 'TN'
    },
    {
        label: 'TURKEY',
        value: 'TR'
    },
    {
        label: 'TURKMENISTAN',
        value: 'TM'
    },
    {
        label: 'TURKS AND CAICOS ISLANDS',
        value: 'TC'
    },
    {
        label: 'TUVALU',
        value: 'TV'
    },
    {
        label: 'UGANDA',
        value: 'UG'
    },
    {
        label: 'UKRAINE',
        value: 'UA'
    },
    {
        label: 'UNITED ARAB EMIRATES',
        value: 'AE'
    },
    {
        label: 'UNITED STATES MINOR OUTLYING ISLANDS',
        value: 'UM'
    },
    {
        label: 'URUGUAY',
        value: 'UY'
    },
    {
        label: 'UZBEKISTAN',
        value: 'UZ'
    },
    {
        label: 'VANUATU',
        value: 'VU'
    },
    {
        label: 'VENEZUELA',
        value: 'VE'
    },
    {
        label: 'VIETNAM',
        value: 'VN'
    },
    {
        label: 'VIRGIN ISLANDS, BRITISH',
        value: 'VG'
    },
    {
        label: 'VIRGIN ISLANDS, U.S.',
        value: 'VI'
    },
    {
        label: 'WALLIS AND FUTUNA',
        value: 'WF'
    },
    {
        label: 'WESTERN SAHARA',
        value: 'EH'
    },
    {
        label: 'YEMEN',
        value: 'YE'
    },
    {
        label: 'ZAMBIA',
        value: 'ZM'
    },
    {
        label: 'ZIMBABWE',
        value: 'ZW'
    }
];

const states = [
    { value: '', label: 'state' },
    { value: 'AK', label: 'AK' },
    { value: 'AL', label: 'AL' },
    { value: 'AR', label: 'AR' },
    { value: 'AZ', label: 'AZ' },
    { value: 'CA', label: 'CA' },
    { value: 'CO', label: 'CO' },
    { value: 'CT', label: 'CT' },
    { value: 'DC', label: 'DC' },
    { value: 'DE', label: 'DE' },
    { value: 'FL', label: 'FL' },
    { value: 'GA', label: 'GA' },
    { value: 'HI', label: 'HI' },
    { value: 'IA', label: 'IA' },
    { value: 'ID', label: 'ID' },
    { value: 'IL', label: 'IL' },
    { value: 'IN', label: 'IN' },
    { value: 'KS', label: 'KS' },
    { value: 'KY', label: 'KY' },
    { value: 'LA', label: 'LA' },
    { value: 'MA', label: 'MA' },
    { value: 'MD', label: 'MD' },
    { value: 'ME', label: 'ME' },
    { value: 'MI', label: 'MI' },
    { value: 'MN', label: 'MN' },
    { value: 'MO', label: 'MO' },
    { value: 'MS', label: 'MS' },
    { value: 'MT', label: 'MT' },
    { value: 'NC', label: 'NC' },
    { value: 'ND', label: 'ND' },
    { value: 'NE', label: 'NE' },
    { value: 'NH', label: 'NH' },
    { value: 'NJ', label: 'NJ' },
    { value: 'NM', label: 'NM' },
    { value: 'NV', label: 'NV' },
    { value: 'NY', label: 'NY' },
    { value: 'OH', label: 'OH' },
    { value: 'OK', label: 'OK' },
    { value: 'OR', label: 'OR' },
    { value: 'PA', label: 'PA' },
    { value: 'RI', label: 'RI' },
    { value: 'SC', label: 'SC' },
    { value: 'SD', label: 'SD' },
    { value: 'TN', label: 'TN' },
    { value: 'TX', label: 'TX' },
    { value: 'UT', label: 'UT' },
    { value: 'VA', label: 'VA' },
    { value: 'VT', label: 'VT' },
    { value: 'WA', label: 'WA' },
    { value: 'WI', label: 'WI' },
    { value: 'WV', label: 'WV' },
    { value: 'WY', label: 'WY' },
    { value: 'AA', label: 'AA' },
    { value: 'AE', label: 'AE' },
    { value: 'AP', label: 'AP' },
    { value: 'AS', label: 'AS' },
    { value: 'FM', label: 'FM' },
    { value: 'GU', label: 'GU' },
    { value: 'MH', label: 'MH' },
    { value: 'MP', label: 'MP' },
    { value: 'PR', label: 'PR' },
    { value: 'PW', label: 'PW' },
    { value: 'VI', label: 'VI' }
];

const statesFullNames = [
    { value: '', label: 'Select State', disabled: true },
    { value: 'Alabama', label: 'Alabama' },
    { value: 'Alaska', label: 'Alaska' },
    { value: 'Arizona', label: 'Arizona' },
    { value: 'Arkansas', label: 'Arkansas' },
    { value: 'Armed Forces Americas', label: 'Armed Forces Americas' },
    {
        value: 'Armed Forces Europe / Middle East / Canada',
        label: 'Armed Forces Europe / Middle East / Canada'
    },
    { value: 'Armed Forces Pacific', label: 'Armed Forces Pacific' },
    { value: 'California', label: 'California' },
    { value: 'Colorado', label: 'Colorado' },
    { value: 'Connecticut', label: 'Connecticut' },
    { value: 'Delaware', label: 'Delaware' },
    { value: 'District of Columbia', label: 'District of Columbia' },
    { value: 'Florida', label: 'Florida' },
    { value: 'Georgia', label: 'Georgia' },
    { value: 'Hawaii', label: 'Hawaii' },
    { value: 'Idaho', label: 'Idaho' },
    { value: 'Illinois', label: 'Illinois' },
    { value: 'Indiana', label: 'Indiana' },
    { value: 'Iowa', label: 'Iowa' },
    { value: 'Kansas', label: 'Kansas' },
    { value: 'Kentucky', label: 'Kentucky' },
    { value: 'Louisiana', label: 'Louisiana' },
    { value: 'Maine', label: 'Maine' },
    { value: 'Maryland', label: 'Maryland' },
    { value: 'Massachusetts', label: 'Massachusetts' },
    { value: 'Michigan', label: 'Michigan' },
    { value: 'Minnesota', label: 'Minnesota' },
    { value: 'Mississippi', label: 'Mississippi' },
    { value: 'Missouri', label: 'Missouri' },
    { value: 'Montana', label: 'Montana' },
    { value: 'Nebraska', label: 'Nebraska' },
    { value: 'Nevada', label: 'Nevada' },
    { value: 'New Hampshire', label: 'New Hampshire' },
    { value: 'New Jersey', label: 'New Jersey' },
    { value: 'New Mexico', label: 'New Mexico' },
    { value: 'New York', label: 'New York' },
    { value: 'North Carolina', label: 'North Carolina' },
    { value: 'North Dakota', label: 'North Dakota' },
    { value: 'Ohio', label: 'Ohio' },
    { value: 'Oklahoma', label: 'Oklahoma' },
    { value: 'Oregon', label: 'Oregon' },
    { value: 'Pennsylvania', label: 'Pennsylvania' },
    { value: 'Rhode Island', label: 'Rhode Island' },
    { value: 'South Carolina', label: 'South Carolina' },
    { value: 'South Dakota', label: 'South Dakota' },
    { value: 'Tennessee', label: 'Tennessee' },
    { value: 'Texas', label: 'Texas' },
    { value: 'Utah', label: 'Utah' },
    { value: 'Vermont', label: 'Vermont' },
    { value: 'Virginia', label: 'Virginia' },
    { value: 'Washington', label: 'Washington' },
    { value: 'West Virginia', label: 'West Virginia' },
    { value: 'Wisconsin', label: 'Wisconsin' },
    { value: 'Wyoming', label: 'Wyoming' }
];

const canadaProvinces = [
    { value: '', label: 'Select Province', disabled: true },
    { value: 'Alberta', label: 'Alberta' },
    { value: 'British Columbia', label: 'British Columbia' },
    { value: 'Manitoba', label: 'Manitoba' },
    { value: 'New Brunswick', label: 'New Brunswick' },
    { value: 'Newfoundland and Labrador', label: 'Newfoundland and Labrador' },
    { value: 'Northwest Territories', label: 'Northwest Territories' },
    { value: 'Nova Scotia', label: 'Nova Scotia' },
    { value: 'Nunavut', label: 'Nunavut' },
    { value: 'Ontario', label: 'Ontario' },
    { value: 'Prince Edward Island', label: 'Prince Edward Island' },
    { value: 'Quebec', label: 'Quebec' },
    { value: 'Saskatchewan', label: 'Saskatchewan' },
    { value: 'Yukon', label: 'Yukon' }
];

const australiaStates = [
    { value: '', label: 'Select State', disabled: true },
    { value: 'ACT', label: 'ACT' },
    { value: 'NSW', label: 'NSW' },
    { value: 'NT', label: 'NT' },
    { value: 'Queensland', label: 'Queensland' },
    { value: 'SA', label: 'SA' },
    { value: 'Tasmania', label: 'Tasmania' },
    { value: 'Victoria', label: 'Victoria' },
    { value: 'WA', label: 'WA' }
];

export { Countries as default, states, statesFullNames, canadaProvinces, australiaStates };
